export const heroData = {
  overline: "Unikalny design, który zachwyca",
  title: {
    line1: "Luksusowe i funkcjonalne",
    line2: "strony WWW dla Twojej firmy",
  },
  description: {
    line1: "Projektujemy spersonalizowane, unikalne rozwiązania cyfrowe,",
    line2: "które budują autorytet i przyciągają klientów premium.",
  },
  buttons: {
    primary: {
      label: "Zobacz Projekty",
      href: "/offer",
    },
    secondary: {
      label: "Współpraca",
      href: "/cooperation",
    },
  },
};
